import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Trace from "@/pages/Trace";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Team from "@/pages/Team";
import Alerts from "@/pages/Alerts";
import Conversations from "@/pages/Conversations";
import Members from "@/pages/Members";
import Payments from "@/pages/Payments";
import Legal from "@/pages/Legal";
import WebLogin from "@/pages/web/WebLogin";
import { WebVerify, Welcome } from "@/pages/web/WebVerify";
import WebApp from "@/pages/web/WebApp";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/legal/:page" element={<Legal />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/app/login" element={<WebLogin />} />
            <Route path="/app/verify" element={<WebVerify />} />
            <Route path="/app/*" element={<WebApp />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
            <Route path="/conversations" element={<ProtectedRoute><Conversations /></ProtectedRoute>} />
            <Route path="/members" element={<ProtectedRoute><Members /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/trace" element={<ProtectedRoute><Trace /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
